import React from 'react'
import { useRouter } from 'next/router'

const useSearchQuery = () => {
  const router = useRouter()

  const searchQueryFromURL = React.useMemo(
    () => (router?.query?.q ?? '') as string,
    [router?.query?.q]
  )
  const hasSearchQueryFromURL = React.useMemo(
    () => Boolean(searchQueryFromURL),
    [searchQueryFromURL]
  )

  return {
    searchQueryFromURL,
    hasSearchQueryFromURL,
  }
}

export default useSearchQuery
